class TopShelfCarouselSection {
  constructor(root) {
    this.root = root;
    this.tabs = Array.from(root.querySelectorAll('[data-top-shelf-tab]'));
    this.panels = Array.from(root.querySelectorAll('[data-top-shelf-panel]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activateTab(tab));
    });

    this.panels.forEach((panel) => this.initCarousel(panel));
  }

  activateTab(activeTab) {
    this.tabs.forEach((tab) => {
      const isActive = tab === activeTab;
      tab.classList.toggle('top-shelf-carousel-section__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.id === activeTab.dataset.target;
      panel.classList.toggle('top-shelf-carousel-section__panel--active', isActive);
    });
  }

  initCarousel(panel) {
    const carousel = panel.querySelector('[data-top-shelf-carousel]');
    if (!carousel) return;

    const track = carousel.querySelector('[data-top-shelf-track]');
    const prevButton = carousel.querySelector('[data-top-shelf-prev]');
    const nextButton = carousel.querySelector('[data-top-shelf-next]');
    if (!track || !prevButton || !nextButton) return;

    const updateButtons = () => {
      const maxScrollLeft = track.scrollWidth - track.clientWidth - 1;
      prevButton.disabled = track.scrollLeft <= 0;
      nextButton.disabled = track.scrollLeft >= maxScrollLeft;
    };

    prevButton.addEventListener('click', () => {
      track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
    });

    nextButton.addEventListener('click', () => {
      track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
    });

    track.addEventListener('scroll', () => updateButtons());
    window.addEventListener('resize', () => updateButtons());

    updateButtons();
  }
}

document.querySelectorAll('.top-shelf-carousel-section').forEach((section) => {
  new TopShelfCarouselSection(section);
});
